import AnalyticsHelper from '../../utils/analytics-helper.js';

export default class DealerFilters {
    constructor(parent, router) {
        this.router = router;
        this.parent = parent;
        this.el = parent.el.querySelector('.fad-filter');
        this.inputs = [...this.el.querySelectorAll('input[type=checkbox]')];
        this.filterActions = this.el.querySelector('.fad-filter-actions');
        this.apply = this.el.querySelector('.fad-filter-apply');
        this.clear = this.el.querySelector('.fad-filter-clear');
        this.results = document.querySelector('.fad-results');
        this.input = parent.el.querySelector('.fad-search-input');
        this.submit = parent.el.querySelector('.fad-search-submit');
        this.filterError = this.el.querySelector('.fad-filter-error');
        this.isFilterRequired = this.el.dataset.filterRequired == 'true' ? true : false;
        this.count = 0;
        this.bind();
       
    }

    show(){
        if(this.router.params.has('query') || this.router.params.has('filters')){
            this.populate();
             ;
        } else {
            this.update();
            this.router.update();
        }

        if (this.router.params.has('query')) {
            if (this.isFilterRequired && !this.router.params.has('filters') ) {
                this.submit.disabled = true;
                 ;
            } else {
                this.submit.disabled = false;
            }
        }
    }
    pageURL() {
        return window.location.href;
    }
    populate() {
        const filters = this.router.params.get('filters')?.split(',') || [];
        this.count = 0;
         ;
        this.inputs.forEach((i) => {
            if(filters.includes(i.value)) {
                i.checked = true;
                this.count++;
            } else {
                i.checked = false;
            }
        });

        this.toggleSubmit();
        this.toggleError();
    }

    toggleSubmit() {
        if(this.isFilterRequired && this.count < 1) {
            this.submit.disabled = true;
             ;
        } else {
            this.submit.disabled = false;
        }

       
    }

    toggleError() {

        if(this.isFilterRequired && this.count < 1 ){
            this.filterError.classList.remove('hide');
             
        } else {
            this.filterError.classList.add('hide');
        }

        
    }

    toggleFilterActions() {     
        if(this.input.value.trim().length == 0 || this.count == 0) {
            this.filterActions.classList.add('hide');
            this.filterError.classList.add('hide');
             
        } else {
            this.filterActions.classList.remove('hide');
            this.filterError.classList.remove('hide');
        }

        
    }

    close() {
        this.el.classList.add('hide');
        this.results.classList.remove('overlay-mask');
    }

    toggle() {
        this.el.classList.toggle('hide');
        this.results.classList.toggle('overlay-mask');
    }

    update(){
        
        const filters = this.inputs.filter((i) => i.checked).map((i) => i.value).join(',');
            filters ? this.router.params.set('filters', filters) : this.router.params.delete('filters');

    }

    bind() {
        this.apply.addEventListener('click', (e) => {
            e.preventDefault();
            this.update();
            this.parent.update();
            this.router.update();
            AnalyticsHelper.template(this.apply, { filters: this.router.params.get('filters'), pageURL: this.pageURL(), query: this.input.value });
            AnalyticsHelper.push(this.apply);
            this.filterActions.classList.add('hide');
        });

        this.clear.addEventListener('click', (e) => {
            e.preventDefault();
            AnalyticsHelper.template(this.clear, { filters: this.router.params.get('filters') });
            AnalyticsHelper.push(this.clear);
            this.inputs.forEach((i) => i.checked = false);
            this.count = 0;
            this.filterActions.classList.add('hide');
            
            if(this.isFilterRequired) {
                this.submit.disabled = true;
                 
            }
            
            this.update();
            this.parent.update();
            this.router.update();
        });

        this.inputs.forEach(item => {
            item.addEventListener('change', (e) => {
                if( e.currentTarget.checked ) {
                    this.count++;
                } else {
                    this.count--;
                }
                
                this.toggleFilterActions();
                this.toggleSubmit();
                this.toggleError();
            })
        })
    }
}
